module.exports = __webpack_public_path__ + "img/oracle-sales.404ab719.png";